import { render, staticRenderFns } from "./HistoricoUsuarioModal.vue?vue&type=template&id=53a20d02"
import script from "./HistoricoUsuarioModal.vue?vue&type=script&lang=js"
export * from "./HistoricoUsuarioModal.vue?vue&type=script&lang=js"
import style0 from "./HistoricoUsuarioModal.vue?vue&type=style&index=0&id=53a20d02&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a20d02')) {
      api.createRecord('53a20d02', component.options)
    } else {
      api.reload('53a20d02', component.options)
    }
    module.hot.accept("./HistoricoUsuarioModal.vue?vue&type=template&id=53a20d02", function () {
      api.rerender('53a20d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modals/HistoricoUsuarioModal.vue"
export default component.exports